export const STATISTICS_COLUMN_ORDER = [
  'userDisplayName',
  'lessonName',
  'userTagA',
  'userTagB',
  'rewardType',
  'score',
  'dateCompleted',
  'dateStarted',
  'timeStarted',
  'timeSpent',
  'convertedTimeSpent',
  'lessonProgressStatus',
  'passed',
] as const;

export type StatisticsColumnName = (typeof STATISTICS_COLUMN_ORDER)[number];

export const columnIndex = (name: StatisticsColumnName): number =>
  STATISTICS_COLUMN_ORDER.indexOf(name);

export const STATISTICS_COLUMN_WIDTHS: Partial<Record<StatisticsColumnName, number>> = {
  userDisplayName: 180,
  lessonName: 220,
  userTagA: 110,
  userTagB: 110,
  rewardType: 90,
  score: 100,
  dateCompleted: 150,
  dateStarted: 130,
  timeStarted: 110,
  timeSpent: 130,
  lessonProgressStatus: 130,
  passed: 110,
};

export const getColumnWidth = (name: string): number | undefined =>
  STATISTICS_COLUMN_WIDTHS[name as StatisticsColumnName];

export const STATISTICS_TABLE_MIN_WIDTH = Object.entries(STATISTICS_COLUMN_WIDTHS)
  .filter(([name]) => name !== 'dateCompleted')
  .reduce((sum, [, width]) => sum + (width ?? 0), 0);
